<ion-row [class.background-grey]="backgroundGrey">
  <ion-col size="3.75" class="ion-no-padding">
    <div class="subtitle" [class.subtitle-margin-top]="shownDates.showSettlementDates && shownDates.showTradeDates">
      {{ 'insights.labels.net-positions' | translate }}
    </div>
  </ion-col>
  <ion-col size="8.25" class="text-small">
    @if (!shownDates.showSettlementDates && !shownDates.showTradeDates) {
      <ion-row>
        <ion-col size="12" class="ion-text-end">
          <span class="label">{{ 'insights.labels.settlement' | translate }}</span>
          <span>{{ shownDates.settlementDateFrom | dateFormat }}</span>
          <span class="dash">-</span>
          <span>{{ shownDates.settlementDateTo | dateFormat }}</span>
        </ion-col>
      </ion-row>
    }
    @if (shownDates.showTradeDates) {
      <ion-row>
        <ion-col size="12" class="ion-text-end">
          <span class="label">{{ 'insights.labels.traded' | translate }}</span>
          <span>{{ shownDates.tradeDateFrom | dateFormat }}</span>
          <span class="dash">-</span>
          <span>{{ shownDates.tradeDateTo | dateFormat }}</span>
        </ion-col>
      </ion-row>
    }
    @if (shownDates.showSettlementDates) {
      <ion-row>
        <ion-col size="12" class="ion-text-end">
          <span class="label">{{ 'insights.labels.settlement' | translate }}</span>
          <span>{{ shownDates.settlementDateFrom | dateFormat }}</span>
          <span class="dash">-</span>
          <span>{{ shownDates.settlementDateTo | dateFormat }}</span>
        </ion-col>
      </ion-row>
    }
  </ion-col>
</ion-row>
